import React, { useState, useEffect } from "react";
import  {


  BarChart2, FileBarChart, Table2, FileSpreadsheet, BarChartBig
} from "lucide-react";
import {
  ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, LabelList, BarChart, Bar, PieChart, Pie, Cell, Legend
} from "recharts";
import * as XLSX from "xlsx";

// PALETA CORPORATIVA
const COLORS = [
  "#003865", "#145DA0", "#61717D", "#6EBE44", "#FDB022"
];

const TABS = [
  { key: "dashboard", label: "Dashboard General", icon: <BarChart2 className="w-5 h-5 mr-1" /> },
  { key: "detalle", label: "Detalle Documentos", icon: <Table2 className="w-5 h-5 mr-1" /> },
  { key: "financiero", label: "Resumen Financiero", icon: <FileBarChart className="w-5 h-5 mr-1" /> },
];

export default function InformesPage() {
  // --- DATA
  const [docs, setDocs] = useState([]);
  const [historico, setHistorico] = useState([]);
  const [loading, setLoading] = useState(true);

  // --- FILTROS
  const [tipo, setTipo] = useState("Todos");
  const [estado, setEstado] = useState("Todos");
  const [desde, setDesde] = useState("");
  const [hasta, setHasta] = useState("");
  const [busqueda, setBusqueda] = useState("");
  const [activeTab, setActiveTab] = useState("dashboard");

  // -------- SIMULA FETCH DE BACKEND (reemplaza por tu API real) --------
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setDocs(generarDocsFake());
      setHistorico(getHistoricoFacturacion());
      setLoading(false);
    }, 900);
  }, []);

  // ------- PREPARA FILTROS --------
  const tiposUnicos = ["Todos", ...Array.from(new Set((docs || []).map((d) => d.tipo)))];
  const estadosUnicos = ["Todos", ...Array.from(new Set((docs || []).map((d) => d.estado)))];
  const clientesUnicos = ["Todos", ...Array.from(new Set((docs || []).map((d) => d.cliente)))];

  let filtered = docs || [];
  if (tipo !== "Todos" && activeTab !== "financiero") filtered = filtered.filter((d) => d.tipo === tipo);
  if (estado !== "Todos" && activeTab !== "financiero") filtered = filtered.filter((d) => d.estado === estado);
  if (desde) filtered = filtered.filter((d) => new Date(d.fecha) >= new Date(desde));
  if (hasta) filtered = filtered.filter((d) => new Date(d.fecha) <= new Date(hasta));
  if (busqueda && busqueda !== "Todos" && activeTab !== "financiero")
    filtered = filtered.filter((d) =>
      (d.cliente + d.consecutivo + d.tipo + d.estado)
        .toLowerCase()
        .includes(busqueda.toLowerCase())
    );

  // Filtrado para financiero
  let historicoFiltrado = historico;
  if (desde) {
    historicoFiltrado = historicoFiltrado.filter(h => {
      const [mes, anio] = h.mes.split(" ");
      const mesNum = new Date(Date.parse(mes + " 1, 2020")).getMonth();
      return new Date(anio, mesNum, 1) >= new Date(desde);
    });
  }
  if (hasta) {
    historicoFiltrado = historicoFiltrado.filter(h => {
      const [mes, anio] = h.mes.split(" ");
      const mesNum = new Date(Date.parse(mes + " 1, 2020")).getMonth();
      return new Date(anio, mesNum, 1) <= new Date(hasta);
    });
  }

  return (
    <div className="min-h-screen bg-gradient-to-tr from-blue-50 via-white to-[#e3eaf6] flex flex-col items-center py-10 px-2">
      <div className="w-full max-w-7xl bg-white rounded-3xl shadow-2xl border border-gray-200 p-7 sm:p-10">
        {/* HEADER */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:gap-3 mb-3">
          <div className="bg-[#003865]/10 rounded-full p-3 w-fit self-start">
            <BarChart2 className="w-8 h-8 text-[#003865]" />
          </div>
          <div className="flex-1">
            <h1 className="text-2xl sm:text-3xl font-black text-[#003865] tracking-tight">
              Informes y Analítica
            </h1>
            <p className="text-gray-700 text-sm mt-1 font-medium">
              Consulta, exporta y analiza tus documentos electrónicos.
            </p>
          </div>
        </div>

        {/* FILTROS */}
        <div className="flex flex-wrap gap-x-3 gap-y-2 mb-6 items-end border-b border-blue-100 pb-4">
          <div className="flex flex-col">
            <label className="text-xs font-semibold text-[#003865] mb-0.5">Fecha Inicial</label>
            <input
              type="date"
              value={desde}
              onChange={e => setDesde(e.target.value)}
              className="border border-gray-300 rounded-lg p-2 text-sm w-[120px]"
            />
          </div>
          <div className="flex flex-col">
            <label className="text-xs font-semibold text-[#003865] mb-0.5">Fecha Final</label>
            <input
              type="date"
              value={hasta}
              onChange={e => setHasta(e.target.value)}
              className="border border-gray-300 rounded-lg p-2 text-sm w-[120px]"
            />
          </div>
          {activeTab !== "financiero" && (
            <>
              <div className="flex flex-col">
                <label className="text-xs font-semibold text-[#003865] mb-0.5">Tipo</label>
                <select
                  value={tipo}
                  onChange={e => setTipo(e.target.value)}
                  className="border border-gray-300 rounded-lg p-2 text-sm w-[125px]"
                >
                  {tiposUnicos.map((t) => (
                    <option key={t}>{t}</option>
                  ))}
                </select>
              </div>
              <div className="flex flex-col">
                <label className="text-xs font-semibold text-[#003865] mb-0.5">Estado</label>
                <select
                  value={estado}
                  onChange={e => setEstado(e.target.value)}
                  className="border border-gray-300 rounded-lg p-2 text-sm w-[125px]"
                >
                  {estadosUnicos.map((e) => (
                    <option key={e}>{e}</option>
                  ))}
                </select>
              </div>
              <div className="flex flex-col">
                <label className="text-xs font-semibold text-[#003865] mb-0.5">Cliente/Proveedor</label>
                <select
                  value={busqueda}
                  onChange={e => setBusqueda(e.target.value)}
                  className="border border-gray-300 rounded-lg p-2 text-sm w-[170px]"
                >
                  {clientesUnicos.map(c => (
                    <option key={c} value={c === "Todos" ? "" : c}>{c}</option>
                  ))}
                </select>
              </div>
            </>
          )}
          {activeTab === "detalle" && (
            <div className="flex flex-col justify-end h-[44px]">
              <button
                onClick={() => exportarExcel(filtered)}
                className="flex items-center gap-2 px-3 py-2 bg-gradient-to-tr from-green-400 via-green-500 to-green-600 border border-green-500 rounded-lg text-white font-bold text-xs shadow hover:brightness-110 hover:scale-105 transition"
              >
                <FileSpreadsheet className="w-4 h-4" /> Excel
              </button>
            </div>
          )}
        </div>

        {/* TABS */}
        <div className="flex gap-2 mb-7 border-b border-blue-100">
          {TABS.map((tab) => (
            <button
              key={tab.key}
              className={`flex items-center gap-1 px-4 py-2 rounded-t-lg font-bold text-sm transition
                ${
                  activeTab === tab.key
                    ? "bg-gradient-to-r from-[#003865]/90 to-[#0d6efd]/80 text-white border-b-2 border-[#003865] shadow"
                    : "text-gray-500 hover:bg-blue-50"
                }
              `}
              onClick={() => setActiveTab(tab.key)}
            >
              {tab.icon} {tab.label}
            </button>
          ))}
        </div>
        <div className="mt-2">
          {activeTab === "dashboard" && <DashboardTab docs={filtered} loading={loading} />}
          {activeTab === "detalle" && <DetalleTab docs={filtered} loading={loading} />}
          {activeTab === "financiero" && <FinancieroTab historico={historicoFiltrado} />}
        </div>
      </div>
    </div>
  );
}

// ---------------------- DASHBOARD TAB ---------------------
function DashboardTab({ docs = [], loading }) {
  if (loading) return <div className="py-14 text-center text-gray-400">Cargando dashboard...</div>;
  if (!docs.length) return <div className="py-10 text-center text-gray-400">No hay datos para mostrar.</div>;
  // KPIs
  const total = docs.length;
  const aceptados = docs.filter(d => d.estado === 'Aceptado').length;
  const rechazados = docs.filter(d => d.estado === 'Rechazado').length;
  const valorTotal = docs.reduce((acc, d) => acc + d.valor, 0);

  // Simple gráfica
  const resumenTipo = Array.from(new Set(docs.map(d=>d.tipo))).map(tipo => ({
    name: tipo, value: docs.filter(d=>d.tipo===tipo).length
  }));
  const resumenEstados = Array.from(new Set(docs.map(d=>d.estado))).map(e=>({
    name: e, value: docs.filter(d=>d.estado===e).length
  }));

  return (
    <div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-5 mb-8">
        <KpiButton color="bg-gradient-to-br from-[#003865] to-[#2865a7] text-white border-[#003865]/70" icon={<FileBarChart />} value={total} label="Total" />
        <KpiButton color="bg-gradient-to-br from-green-700 to-green-500 text-white border-green-800/80" icon={<BarChart2 />} value={aceptados} label="Aceptados" />
        <KpiButton color="bg-gradient-to-br from-[#FDB022] to-[#f7c873] text-white border-yellow-600/60" icon={<BarChart2 />} value={rechazados} label="Rechazados" />
        <KpiButton color="bg-gradient-to-br from-[#61717D] to-[#003865] text-white border-[#61717D]/70" icon={<FileBarChart />} value={valorTotal.toLocaleString("es-CO", {style:"currency",currency:"COP",minimumFractionDigits:0})} label="Valor Total" />
      </div>
      {/* Graficas simples */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-7 items-stretch">
        <div className="bg-white rounded-2xl shadow-xl border border-blue-100 p-6 flex flex-col items-center min-h-[180px]">
          <span className="text-[#003865] font-bold mb-3 text-base">Documentos por Tipo</span>
          <ResponsiveContainer width="100%" height={130}>
            <BarChart data={resumenTipo}>
              <XAxis dataKey="name" tickLine={false} fontSize={12} />
              <YAxis allowDecimals={false} tickLine={false} fontSize={12} />
              <Tooltip />
              <Bar dataKey="value" fill="#003865" barSize={36}>
                <LabelList dataKey="value" position="top" fill="#145DA0" fontSize={12} />
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
        <div className="bg-white rounded-2xl shadow-xl border border-blue-100 p-6 flex flex-col items-center min-h-[180px]">
          <span className="text-[#003865] font-bold mb-3 text-base">Documentos por Estado</span>
          <ResponsiveContainer width="100%" height={130}>
            <PieChart>
              <Pie data={resumenEstados} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={50}>
                {resumenEstados.map((entry, idx) => (
                  <Cell key={entry.name} fill={COLORS[idx % COLORS.length]} />
                ))}
                <LabelList dataKey="value" position="outside" />
              </Pie>
              <Tooltip />
              <Legend verticalAlign="bottom" iconType="circle" />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
function KpiButton({ color, icon, value, label }) {
  return (
    <div className={`flex flex-col items-start rounded-2xl shadow-xl px-5 py-6 relative overflow-hidden border-2 ${color}`}>
      <div className="absolute top-3 right-4 opacity-10 text-[64px]">{icon}</div>
      <span className="text-base font-semibold mb-2 drop-shadow">{label}</span>
      <span className="text-3xl font-black tracking-tight drop-shadow">{value}</span>
    </div>
  );
}

// ---------------------- DETALLE TAB ------------------------
function DetalleTab({ docs = [], loading = false }) {
  const [pagina, setPagina] = useState(1);
  const filasPorPagina = 10;
  const totalPaginas = Math.max(1, Math.ceil(docs.length / filasPorPagina));
  const paginados = docs.slice((pagina - 1) * filasPorPagina, pagina * filasPorPagina);

  return (
    <div>
      <div className="overflow-x-auto rounded-2xl border bg-white shadow mb-4">
        <table className="min-w-[780px] w-full text-xs sm:text-[13px] text-gray-800">
          <thead>
            <tr>
              <th className="px-2 py-3 bg-blue-50 text-left font-bold uppercase tracking-wide sticky top-0 z-10">Consecutivo</th>
              <th className="px-2 py-3 bg-blue-50 text-left font-bold uppercase tracking-wide sticky top-0 z-10">Tipo</th>
              <th className="px-2 py-3 bg-blue-50 text-left font-bold uppercase tracking-wide sticky top-0 z-10">Cliente</th>
              <th className="px-2 py-3 bg-blue-50 text-center font-bold uppercase tracking-wide sticky top-0 z-10">Fecha</th>
              <th className="px-2 py-3 bg-blue-50 text-right font-bold uppercase tracking-wide sticky top-0 z-10">Valor</th>
              <th className="px-2 py-3 bg-blue-50 text-center font-bold uppercase tracking-wide sticky top-0 z-10">Estado</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={7} className="py-10 text-center text-gray-400">
                  Cargando datos...
                </td>
              </tr>
            ) : paginados.length === 0 ? (
              <tr>
                <td colSpan={7} className="py-8 text-center text-gray-400 font-medium">
                  No hay documentos para mostrar.
                </td>
              </tr>
            ) : (
              paginados.map((d, idx) => (
                <tr
                  key={d.id}
                  className={`border-t ${idx % 2 === 0 ? "bg-gray-50" : "bg-white"} hover:bg-blue-50 transition`}
                >
                  <td className="px-2 py-2 border-b border-gray-100">{d.consecutivo}</td>
                  <td className="px-2 py-2 border-b border-gray-100">{d.tipo}</td>
                  <td className="px-2 py-2 border-b border-gray-100">{d.cliente}</td>
                  <td className="px-2 py-2 border-b border-gray-100 text-center">{d.fecha.toLocaleDateString("es-CO")}</td>
                  <td className="px-2 py-2 border-b border-gray-100 text-right font-bold text-blue-900">
                    {d.valor.toLocaleString("es-CO", { style: "currency", currency: "COP", minimumFractionDigits: 0 })}
                  </td>
                  <td className="px-2 py-2 border-b border-gray-100 text-center">
                    <span className={`inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-semibold border
                      ${d.estado === "Aceptado"
                        ? "bg-green-50 text-green-700 border-green-100"
                        : d.estado === "Rechazado"
                        ? "bg-yellow-50 text-yellow-900 border-yellow-200"
                        : "bg-gray-50 text-gray-700 border-gray-200"
                      }
                    `}>{d.estado}</span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      {/* PAGINADOR */}
      <div className="flex justify-between items-center px-2 py-2">
        <span className="text-xs text-gray-600">
          Página {pagina} de {totalPaginas} • {docs.length} registros
        </span>
        <div className="flex gap-1">
          <button disabled={pagina === 1} onClick={() => setPagina(1)} className={`px-2 py-1 rounded-l bg-gray-100 border border-gray-300 text-sm font-bold hover:bg-blue-50 disabled:opacity-50`}>{"<<"}</button>
          <button disabled={pagina === 1} onClick={() => setPagina(p => Math.max(1, p - 1))} className="px-2 py-1 bg-gray-100 border border-gray-300 text-sm font-bold hover:bg-blue-50 disabled:opacity-50">{"<"}</button>
          <button disabled={pagina === totalPaginas} onClick={() => setPagina(p => Math.min(totalPaginas, p + 1))} className="px-2 py-1 bg-gray-100 border border-gray-300 text-sm font-bold hover:bg-blue-50 disabled:opacity-50">{">"}</button>
          <button disabled={pagina === totalPaginas} onClick={() => setPagina(totalPaginas)} className="px-2 py-1 rounded-r bg-gray-100 border border-gray-300 text-sm font-bold hover:bg-blue-50 disabled:opacity-50">{">>"}</button>
        </div>
      </div>
    </div>
  );
}

// --------- FINANCIERO OPTIMIZADO (incluye todo el código de la versión anterior) ---------
function FinancieroTab({ historico = [] }) {
  // ... igual que en la versión anterior
  if (!historico.length) {
    return (
      <div className="text-gray-400 text-center py-8">
        No hay información para el rango seleccionado.
      </div>
    );
  }
  const ahora = new Date();
  const mesActual = ahora.toLocaleString("es-CO", { month: "short" }).toUpperCase() + " " + ahora.getFullYear();
  const mesAnterior = new Date(ahora.getFullYear(), ahora.getMonth() - 1, 1)
    .toLocaleString("es-CO", { month: "short" }).toUpperCase() +
    " " + new Date(ahora.getFullYear(), ahora.getMonth() - 1, 1).getFullYear();

  const actual = historico.find(h => h.mes === mesActual);
  const anterior = historico.find(h => h.mes === mesAnterior);

  const promDocs = historico.length
    ? Math.round(historico.reduce((acc, h) => acc + h.cantidad, 0) / historico.length)
    : 0;

  function exportarHistoricoExcel() {
    const ws = XLSX.utils.json_to_sheet(
      historico.map((h) => ({
        Mes: h.mes,
        "Cantidad Documentos": h.cantidad,
        "Valor Facturado": h.valor,
      }))
    );
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Histórico");
    XLSX.writeFile(wb, "historico_facturacion.xlsx");
  }

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-wrap gap-4 mb-2">
        <div className="flex flex-col items-start justify-center bg-[#003865]/90 text-white rounded-2xl px-5 py-3 shadow border-2 border-[#145DA0] min-w-[150px]">
          <span className="text-xs font-medium tracking-tight mb-1">Valor Facturado Mes Anterior</span>
          <span className="text-xl font-extrabold tracking-tight">
            {anterior
              ? anterior.valor.toLocaleString("es-CO", { style: "currency", currency: "COP", minimumFractionDigits: 0 })
              : "$0"}
          </span>
        </div>
        <div className="flex flex-col items-start justify-center bg-[#6EBE44]/90 text-white rounded-2xl px-5 py-3 shadow border-2 border-[#61717D] min-w-[150px]">
          <span className="text-xs font-medium tracking-tight mb-1">Valor Calculado Mes Actual</span>
          <span className="text-xl font-extrabold tracking-tight">
            {actual
              ? actual.valor.toLocaleString("es-CO", { style: "currency", currency: "COP", minimumFractionDigits: 0 })
              : "$0"}
          </span>
        </div>
        <div className="flex flex-col items-start justify-center bg-[#145DA0] text-white rounded-2xl px-5 py-3 shadow border-2 border-[#003865] min-w-[150px]">
          <span className="text-xs font-medium tracking-tight mb-1 flex items-center gap-1"><BarChartBig className="w-4 h-4" />Promedio mes</span>
          <span className="text-xl font-extrabold tracking-tight">{promDocs}</span>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 items-start">
        {/* Tabla histórica */}
        <div className="bg-white rounded-2xl shadow border border-blue-100 p-4">
          <div className="flex items-center justify-between mb-2">
            <span className="text-[#003865] font-bold text-base">Histórico Documentos y Facturación</span>
            <button
              onClick={exportarHistoricoExcel}
              className="flex items-center gap-2 px-3 py-2 bg-gradient-to-tr from-green-400 via-green-500 to-green-600 border border-green-500 rounded-lg text-white font-bold text-xs shadow hover:brightness-110 hover:scale-105 transition"
            >
              <FileSpreadsheet className="w-4 h-4" /> Excel
            </button>
          </div>
          <div className="overflow-x-auto">
            <table className="min-w-[300px] w-full text-xs text-gray-800">
              <thead>
                <tr>
                  <th className="py-2 px-2 bg-blue-50 font-bold uppercase text-left rounded-tl-2xl">Mes</th>
                  <th className="py-2 px-2 bg-blue-50 font-bold uppercase text-center">Docs</th>
                  <th className="py-2 px-2 bg-blue-50 font-bold uppercase text-right rounded-tr-2xl">Valor</th>
                </tr>
              </thead>
              <tbody>
                {historico.map((h, idx) => (
                  <tr key={h.mes} className={idx % 2 === 0 ? "bg-gray-50" : "bg-white"}>
                    <td className="py-1 px-2">{h.mes}</td>
                    <td className="py-1 px-2 text-center">{h.cantidad}</td>
                    <td className="py-1 px-2 text-right font-bold text-blue-900">
                      {h.valor.toLocaleString("es-CO", {
                        style: "currency",
                        currency: "COP",
                        minimumFractionDigits: 0,
                      })}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        {/* Gráficos apilados */}
        <div className="flex flex-col gap-5">
          {/* Tendencia Documentos */}
          <div className="bg-white rounded-2xl shadow border border-blue-100 p-4 min-h-[165px] flex flex-col">
            <span className="text-[#003865] font-bold mb-2 text-sm">Tendencia Documentos Emitidos</span>
            <ResponsiveContainer width="100%" height={90}>
              <LineChart data={historico}>
                <XAxis dataKey="mes" fontSize={11} />
                <YAxis allowDecimals={false} fontSize={11} width={26} />
                <Tooltip />
                <Line
                  type="monotone"
                  dataKey="cantidad"
                  stroke="#003865"
                  strokeWidth={2.5}
                  dot={{ r: 5, stroke: "#FDB022", strokeWidth: 2, fill: "#fff" }}
                  activeDot={{ r: 6 }}
                >
                  <LabelList dataKey="cantidad" position="top" fill="#003865" fontSize={10} />
                </Line>
              </LineChart>
            </ResponsiveContainer>
          </div>
          {/* Tendencia Valor */}
          <div className="bg-white rounded-2xl shadow border border-blue-100 p-4 min-h-[165px] flex flex-col">
            <span className="text-[#003865] font-bold mb-2 text-sm">Tendencia Valor Facturado</span>
            <ResponsiveContainer width="100%" height={90}>
              <LineChart data={historico}>
                <XAxis dataKey="mes" fontSize={11} />
                <YAxis tickFormatter={v => v / 1000000 + "M"} fontSize={11} width={32} />
                <Tooltip formatter={v => v.toLocaleString("es-CO", { style: "currency", currency: "COP" })} />
                <Line
                  type="monotone"
                  dataKey="valor"
                  stroke="#6EBE44"
                  strokeWidth={2.5}
                  dot={{ r: 5, stroke: "#145DA0", strokeWidth: 2, fill: "#fff" }}
                  activeDot={{ r: 6 }}
                >
                  <LabelList dataKey="valor" position="top" fill="#6EBE44" fontSize={10} formatter={v => v.toLocaleString("es-CO", { style: "currency", currency: "COP" })} />
                </Line>
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>
  );
}

// ----------- SIMULADORES -----------
// (En producción reemplaza por tu API real)
function generarDocsFake() {
  const clientes = [
    "Alimentos Rivera", "Logística Express", "Papeles y Empaques",
    "Tecnología SAS", "Distribuciones Fedelza"
  ];
  const estados = ["Aceptado", "Rechazado", "Pendiente"];
  const tipos = ["Factura", "Documento Soporte", "Nota Crédito"];
  const docs = [];
  for (let i = 1; i <= 53; i++) {
    const tipo = tipos[i % tipos.length];
    const cliente = clientes[i % clientes.length];
    const estado = estados[Math.floor(Math.random() * estados.length)];
    const fecha = new Date(2025, 4, Math.floor(Math.random() * 28) + 1);
    const valor = Math.floor(Math.random() * 4000000) + 50000;
    docs.push({
      id: i,
      tipo,
      cliente,
      fecha,
      valor,
      estado,
      consecutivo:
        tipo === "Factura"
          ? `FV-${1000 + i}`
          : tipo === "Documento Soporte"
          ? `DS-${10000 + i}`
          : `NC-${500 + i}`,
      seleccionado: false,
    });
  }
  return docs;
}
function getHistoricoFacturacion() {
  const hoy = new Date();
  return Array(7)
    .fill(0)
    .map((_, idx) => {
      const date = new Date(hoy.getFullYear(), hoy.getMonth() - (6 - idx), 1);
      const mes = date.toLocaleString("es-CO", { month: "short" }).toUpperCase() + " " + date.getFullYear();
      const cantidad = Math.floor(Math.random() * 60) + 12;
      const valor = cantidad * (2500 + Math.floor(Math.random() * 1500));
      return { mes, cantidad, valor };
    });
}

// ---------- EXPORTAR EXCEL ---------
function exportarExcel(data) {
  if (!data || data.length === 0) {
    alert("No hay datos para exportar.");
    return;
  }
  const ws = XLSX.utils.json_to_sheet(
    data.map((d) => ({
      Consecutivo: d.consecutivo,
      Tipo: d.tipo,
      Cliente: d.cliente,
      Fecha: d.fecha.toLocaleDateString("es-CO"),
      Valor: d.valor,
      Estado: d.estado,
    }))
  );
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Documentos");
  XLSX.writeFile(wb, "documentos.xlsx");

}
export { DashboardTab, generarDocsFake };

